<ppb-start-container
  [showUserIcon]="false"
  [width]="'wide'"
>
  <div *ngIf="!(isLoading$ | async)">
    <div *ngIf="!error">
      <ng-container [ngSwitch]="state">
        <ng-container *ngSwitchCase="'INVITE'">
          <h2 i18n="@@user.handle_invitation_title">Obsłuż zaproszenie</h2>
          <p i18n="@@user.handle_invitation">
            Admnistrator bezpieczeństwa {{invitationInfo.abpbName}} {{invitationInfo.abpbLastName}}
            ({{invitationInfo.abpbEmail}}) prosi o zgodę na udzielenie dostępu do zarządzania Twoimi uprawnieniami na
            Portalu
            Partnera Biznesowego. Administrator Bezpieczeństwa reprezentuje następujących partnerów
            biznesowych: {{partnersNames}}
          </p>
        </ng-container>
        <ng-container *ngSwitchCase="'ACCEPT'">
          <h2 i18n="@@user.invitation_title_accepted">Zaproszenie zaakceptowane</h2>
          <p i18n="@@user.invitation_accepted">
            Zaakceptowałeś zaproszenie. Administrator Bezpieczeństwa
            {{invitationInfo.abpbName}} {{invitationInfo.abpbLastName}} ({{invitationInfo.abpbEmail}})
            uzyskał dostęp do zarządzania Twoimi uprawnieniami na Portalu Partnera Biznesowego.
          </p>
          <pseic-async-button
            fxLayoutAlign="center"
            (buttonClicked)="goToHomePage()"
            i18n="@@common.go_to_home_page"
          >Powrót do strony głównej
          </pseic-async-button>
        </ng-container>
        <ng-container *ngSwitchCase="'REJECT'">
          <h2 i18n="@@user.invitation_title_rejected">Zaproszenie odrzucone</h2>

          <p i18n="@@user.invitation_rejected">Odrzuciłeś zaproszenie. Administrator Bezpieczeństwa
            {{invitationInfo.abpbName}} {{invitationInfo.abpbLastName}} ({{invitationInfo.abpbEmail}})
            nie uzyskał dostępu do zarządzania Twoimi uprawnieniami na Portalu Partnera Biznesowego.
          </p>
          <pseic-async-button
            fxLayoutAlign="center"
            (buttonClicked)="goToHomePage()"
            i18n="@@common.go_to_home_page"
          >Powrót do strony głównej
          </pseic-async-button>
        </ng-container>
      </ng-container>
    </div>
  </div>
  <div *ngIf="!error && state === 'INVITE'"
       fxLayout="row"
       fxLayoutAlign="end center"
       fxLayoutGap="8px">
    <pseic-async-button
      [flavor]="'NEGATIVE'"
      [isLoading$]="isLoading$"
      (buttonClicked)="handleInvitation('REJECT')"
      i18n="@@user.rejected"
    >Nie zgadzam się
    </pseic-async-button>
    <pseic-async-button
      [isLoading$]="isLoading$"
      (buttonClicked)="handleInvitation('ACCEPT')"
      i18n="@@user.accepted"
    >Wyrażam zgodę
    </pseic-async-button>
  </div>

  <div *ngIf="error">
    <p fxLayoutAlign="center">{{getErrors(error)}}</p>
    <pseic-async-button
      fxLayoutAlign="center"
      (buttonClicked)="goToHomePage()"
      i18n="@@common.go_to_home_page"
    >Powrót do strony głównej
    </pseic-async-button>
  </div>
</ppb-start-container>
